import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  TagRightIcon,
  useToast,
  VStack
} from '@chakra-ui/react'
import { Form } from './Form'
import useSeasons from './hooks/useSeasons'
import { AdminSeason } from '@olagg/db-types'
import { SeasonFormData } from '@olagg/validation-schemas/season.schema'

const Edit = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getSeason, updateSeason, loading } = useSeasons()

  const [season, setSeason] = useState<AdminSeason | null>(null)
  const [loadingSeason, setLoadingSeason] = useState(true)

  useEffect(() => {
    const loadSeason = async () => {
      if (!id) return
      try {
        setLoadingSeason(true)
        const seasonData = await getSeason(id)
        setSeason(seasonData.gameSeason)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la temporada',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate('/seasons')
      } finally {
        setLoadingSeason(false)
      }
    }

    loadSeason()
  }, [id])

  const onSubmit = async (data: SeasonFormData) => {
    if (!season) return

    try {
      await updateSeason(season.id, data)
      toast({
        title: 'Temporada actualizada',
        description: 'La temporada ha sido actualizada exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate('/seasons')
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar la temporada',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate('/seasons')
  }

  if (loadingSeason) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!season) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Temporada no encontrada
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar temporada</Heading>

        <Form
          initialData={season}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default Edit;